export class User {
  constructor (user) {
    this.login = user ? user.login : ''
    this.password = user ? user.password : ''
  }
}
export class UpdateMailUser {
  constructor (updateMail) {
    this.login = updateMail ? updateMail.login : null
    this.personneId = updateMail ? updateMail.personneId : null
    this.oldMail = updateMail ? updateMail.oldMail : ''
    this.mail = updateMail ? updateMail.mail : ''
    this.confirmedMail = updateMail ? updateMail.confirmedMail : ''
  }
}
export class CreateUser {
  constructor (createMail) {
    this.id = createMail ? createMail.id : null
    this.codeAcces = createMail ? createMail.codeAcces : null
    this.groupe = createMail ? createMail.groupe : null
    this.civilite = createMail ? createMail.civilite : null
    this.prenom = createMail ? createMail.prenom : null
    this.nom = createMail ? createMail.nom : null
    this.telephone = createMail ? createMail.telephone : null
    this.fax = createMail ? createMail.fax : null
    this.emailPerso = createMail ? createMail.emailPerso : null
    this.emailPro = createMail ? createMail.emailPro : null
    this.adresse = createMail ? createMail.adresse : null
    this.adresseComplement = createMail ? createMail.adresseComplement : null
    this.codePostal = createMail ? createMail.codePostal : null
    this.ville = createMail ? createMail.ville : null
    this.pays = createMail ? createMail.pays : null
  }
}
export class UpdateUser {
  constructor (updateUser) {
    this.updateUser = updateUser ? updateUser.updateUser : null
    this.id = updateUser ? updateUser.id : null
    this.groupe = updateUser ? updateUser.groupe : null
    this.civilite = updateUser ? updateUser.civilite : null
    this.prenom = updateUser ? updateUser.prenom : null
    this.nom = updateUser ? updateUser.nom : null
    this.telephone = updateUser ? updateUser.telephone : null
    this.fax = updateUser ? updateUser.fax : null
    this.emailPro = updateUser ? updateUser.emailPro : null
    this.adresse = updateUser ? updateUser.adresse : null
    this.adresseComplement = updateUser ? updateUser.adresseComplement : null
    this.codePostal = updateUser ? updateUser.codePostal : null
    this.ville = updateUser ? updateUser.ville : null
    this.pays = updateUser ? updateUser.pays : null
    this.dateEnvoieLogin = updateUser ? updateUser.dateEnvoieLogin : null
    this.dateEnvoiePassword = updateUser ? updateUser.dateEnvoiePassword : null
    this.nbEssaisQuestionSecrete = updateUser ? updateUser.nbEssaisQuestionSecrete : null
    this.adminRestricted = updateUser ? updateUser.adminRestricted : null
    this.logsAdminAccess = updateUser ? updateUser.logsAdminAccess : null
    this.restrictionList = updateUser ? updateUser.restrictionList : null
    this.login = updateUser ? updateUser.login : null
  }
}
export class ChangePasswordUser {
  constructor (changePassword) {
    this.login = changePassword ? changePassword.login : ''
    this.password = changePassword ? changePassword.password : ''
    this.password2 = changePassword ? changePassword.password2 : ''
    this.password3 = changePassword ? changePassword.password3 : ''
  }
}
export class FileToDownload {
  constructor (fileToDownload) {
    this.nomFichier = fileToDownload ? fileToDownload.nomFichier : ''
    this.idPorteur = fileToDownload ? fileToDownload.idPorteur : ''
    this.cardId = fileToDownload ? fileToDownload.cardId : ''
    this.hierarchieEntrepriseIdList = fileToDownload ? fileToDownload.hierarchieEntrepriseIdList : []
    this.realFileNameToDownload = fileToDownload ? fileToDownload.realFileNameToDownload : ''
    this.keyFolder = fileToDownload ? fileToDownload.keyFolder : ''
    this.login = fileToDownload ? fileToDownload.login : ''
  }
}
